import React from 'react';
import { Loader2 } from 'lucide-react';

interface QuizSubmitModalProps {
  isOpen: boolean;
  day: number;
  totalCount: number;
  answeredCount: number;
  unansweredList: { questionId: number; pos: number; index: number }[];
  submitError: string | null;
  isSubmitting?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  onJumpToQuestion: (index: number) => void;
}

export const QuizSubmitModal: React.FC<QuizSubmitModalProps> = ({
  isOpen,
  day,
  totalCount,
  answeredCount,
  unansweredList,
  submitError,
  isSubmitting = false,
  onClose,
  onSubmit,
  onJumpToQuestion,
}) => {
  if (!isOpen) return null;

  const isAllAnswered = answeredCount === totalCount;

  return (
    <div className="fc-modal-overlay" onClick={isSubmitting ? undefined : onClose}>
      <div className="fc-modal-box" onClick={(e) => e.stopPropagation()}>
        <h3 className="fc-modal-title">
          Bạn đã trả lời {answeredCount}/{totalCount} câu.
        </h3>

        {isAllAnswered ? (
          <p className="fc-modal-desc">
            Bạn có chắc chắn muốn hoàn thành Ngày {day}? Sau khi hoàn thành, câu trả lời của ngày
            này sẽ được khóa và không thể sửa lại.
          </p>
        ) : (
          <>
            <p className="fc-modal-desc">
              Cần trả lời đủ {totalCount} câu trước khi hoàn thành. Nhấn vào số câu dưới đây để
              chuyển đến câu chưa làm:
            </p>

            <div className="fc-unanswered-grid">
              {unansweredList.map((item) => (
                <button
                  key={item.questionId}
                  type="button"
                  className="fc-unans-badge"
                  onClick={() => {
                    onJumpToQuestion(item.index);
                    onClose();
                  }}
                  title={`Chuyển đến câu ${item.pos}`}
                >
                  {item.pos}
                </button>
              ))}
            </div>
          </>
        )}

        {submitError && <div className="fc-modal-error">{submitError}</div>}

        <div className="fc-modal-footer">
          <button
            type="button"
            className="fc-modal-btn cancel"
            onClick={onClose}
            disabled={isSubmitting}
          >
            Quay lại
          </button>

          {isAllAnswered && (
            <button
              type="button"
              className="fc-modal-btn confirm"
              onClick={onSubmit}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                  <Loader2 className="fc-spinner-rotate" size={14} />
                  <span>Đang nộp bài...</span>
                </span>
              ) : (
                `Hoàn thành Ngày ${day}`
              )}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

